import React from 'react'
import './about.css'
import ME from '../../assets/emoji.png'
import {RiAwardLine} from 'react-icons/ri'
import {HiOutlineUsers} from 'react-icons/hi'
import {VscFolderLibrary} from 'react-icons/vsc'

const about = () => {
  return (
    <section id="about">
      <h5>Saiba Mais</h5>
      <h2>Sobre Mim</h2>

      <div className="container about__container">
        <div className="about__me">
          <figure className="about__me-image">
            <img src={ME} alt="me in draw" />
          </figure>
        </div>

        <div className="about__content">
          <div className="about__cards">
            <article className='about__card'>
              <RiAwardLine className='about__icon'/>
              <h5>Experiência</h5>
              <small>8+ meses</small>
            </article>
            <article className='about__card'>
              <HiOutlineUsers className='about__icon'/>
              <h5>Clientes</h5>
              <small>2+</small>
            </article>
            <article className='about__card'>
              <VscFolderLibrary className='about__icon'/>
              <h5>Projetos</h5>
              <small>20+</small>
            </article>
          </div>
          <p>Sou formada em Eng. de Produção desde 2017, tive meu primeiro contato com programação em 2012 com uma cadeira da faculdade, onde estudei Portugol e C++; em março de 2021, com incentivo do meu irmão, que é Desenvolvedor Back-End, decidi investir nessa área que tanto me desafia a dar o meu melhor, e iniciei meus estudos em Python.</p>
 
          <p>Logo, em setembro de 2021, me encaminhei para a área de Front-End e comecei a estudar HTML, CSS, JavaScript e React; hoje estou em busca da minha primeira oportunidade na área e focada em me tornar uma grande Desenvolvedora Front-End | React;</p>
          <p>Atualmente faço projetos, como: desenvolvimento de landing pages responsivas e desenvolvimento de aplicações web em React.</p>

          <a href="#contact" className='btn btn-primary'>Vamos conversar</a>
        </div>
      </div>
    </section>
  )
}

export default about